import React from 'react';

// import getEmployeeById from '../../utils/getEmployeeById';

function leaveTypeToName(str) {
  const types = {
    vacation: 'Absentie',
    sick: 'Ziek',
    absence: 'Niet beschikbaar',
    dentist: 'Tandarts',
    doctor: 'Dokter',
    '55-day': '55+ dag',
    holiday: 'Vrije dag',
    'tvt-day': 'TvT vrije dag',
    'unpaid-leave': 'Onbetaald verlof',
  };

  return typeof types[str] !== 'undefined' ? types[str] : 'Anders';
}

/**
 * List employees that are on leave
 *
 * @param props
 * @returns {null|React.Component}
 */
export default (props) => {
  const onLeave = props.onLeave.map(employee => (
    <div className="d-flex" key={employee.id}>
      <div className="text-ellipsis flex-grow-1">
        {employee.user.fullname}
      </div>

      <div className="text-nowrap">
        {leaveTypeToName(employee.type)}
      </div>
    </div>
  ));

  return onLeave.length ? (
    <div className="daylist__leave">
      Afwezig:
      <div>
        {onLeave}
      </div>
    </div>
  ) : null;
};



// WEBPACK FOOTER //
// ./src/components/Grid/OnLeave.js